export default (plugin) => {
  const keySuffix = plugin.metadata.keySuffix
    ? `_${plugin.metadata.keySuffix}`
    : '';
  return `${plugin.metadata.domain}_${plugin.metadata.type}${keySuffix}`;
};
